import * as React from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { cn } from '@companion-professional/webutils';
import { Circle } from 'lucide-react';

// DropdownMenuRadioItem is a radio button that can be used to select between multiple options.  This component must
// be inside a <DropdownMenuRadioGroup/> component.
// Key Parameters:
//   value: string - the value of the radio button
export const DropdownMenuRadioItem = React.forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.RadioItem>,
  React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.RadioItem>
>(({ className, children, ...props }, ref) => (
  <DropdownMenuPrimitive.RadioItem
    ref={ref}
    className={cn(
      'relative',
      'flex',
      'cursor-default',
      'select-none',
      'items-center',
      'rounded-md',
      'py-1.5',
      'pl-8',
      'pr-2',
      'text-md',
      'outline-none',
      'transition-colors',
      'focus:bg-accent',
      'focus:text-on-accent',
      'cursor-pointer',
      'data-[disabled]:pointer-events-none',
      'data-[disabled]:opacity-50',
      className
    )}
    {...props}
  >
    <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
      <DropdownMenuPrimitive.ItemIndicator>
        <Circle className="h-2 w-2 fill-current" />
      </DropdownMenuPrimitive.ItemIndicator>
    </span>
    {children}
  </DropdownMenuPrimitive.RadioItem>
));
DropdownMenuRadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;
